import { Line } from "react-chartjs-2";

import { useGetSummaryLineChartProperties } from "./useGetSummaryLineChartProperties";

import styles from "./SummaryLineChart.module.scss";

export const SummaryLineChart: React.FC = () => {
  const { data, plugins, options, chartRef, isLoading } = useGetSummaryLineChartProperties();

  return (
    <div className={styles.container}>
      <div className={styles.lineChartContainer}>
        {isLoading && <div className={styles.chartSkeleton} />}
        <div className={isLoading ? styles.chartHidden : styles.chartVisible}>
          <Line className={styles.lineChart} data={data} options={options} plugins={plugins} ref={chartRef} />
        </div>
      </div>
    </div>
  );
};
